module.exports = __webpack_public_path__ + "static/media/anc3ru.8d7ef8a1.pdf";